import { gql } from "@apollo/client";

export const ON_INSURANCE_WEBHOOK = gql`
  subscription Subscription($pull_id: String!) {
    onPullInsurance(pull_id: $pull_id) {
      widget_id
      team_id
      pull_id
      status
      meta_data
      event_type
      data
    }
  }
`;

export const ON_EMPLOYEE_UPDATE = gql`
  subscription Subscription($dealership_id: Int!) {
    onEmployeeUpdate(dealership_id: $dealership_id) {
      dealership_id
      employee_user_id
      employee_details {
        employee {
          role
          employee_user_id
          last_name
          first_name
          email
          mobile_number
          previous_target
          assigned_target
          completed
          status
          percentage
          quotes_requested
          requested_percentage
          notification_preference
          verification_preference
          appointment_preference
          review_preference
          referral_preference
          knowledge_hub_preference
          csi_preference
          prequal_preference
          id_verification_preference
          app_download_preference
          premiums_verified
          premiums_req_quote
          premiums_captured
          customers_captured
          lines_written
          verification_workflow_id
          is_active
          review_provided 
          referral_provided 
          appointment_set 
          apps_downloaded 
          satisfied_yes 
          satisfied_no
          watched_artifacts
          employee_code
        }
        errors {
          code
          type
          message
        }
      }
      errors {
        code
        type
        message
      }
    }
  }
`;

export const ON_FETCH_INSURANCE = gql`
  subscription Subscription($dealership_id: Int!) {
    onFetchInsurance(dealership_id: $dealership_id) {
      employee_user_id
      dealership_id
      insurance_details {
        total
        errors {
          type
          code
          message
        }
        customers {
          surveyResponse {
            question
            answer
          }
          videoResponse {
            title
            watched_secs
            total_secs
            last_watched_secs
          }
          reviewResponse {
            answer
            message
            review_question
            isReview
          }
          referralResponse {
            name
            mobile_number
            referral_question
          }
          appointmentResponse {
            preference
            time
            date
          }
          dealership {
            city
            street
            zipcode
            number
            state
          }
          agentDetail {
            full_name
            full_address
            agency_name
            email
            phone_number
          }
          customer {
            date
            user_id
            last_name
            first_name
            mfa_preference
            carrier_password
            carrier_userid
            insurance_carrier
            third_field
            watched_artifacts
          }
          contact {
            address
            email
            mobile_number
          }
          employee {
            employee_user_id
            employee_lastname
            employee_firstname
            mobile_number
            email
          }
          vehicles {
            year
            make
            model
            vehicle_status_id
            vin
          }
          insuranceList {
            policy {
              policy_number
              policy_begin
              policy_end
              collision_deductible
              comp_deductible
              carrier_name
              is_cancelled
              total_premium
              is_issue
              created_at
            }
            documents {
              document_name
              document_url
            }
          }
          requestQuote {
            customerStatus
            customerStatusId
            linesWritten
          }
          questionnaire {
            question
            options
          }
          isAppsDownloaded
        }
      }
      errors {
        code
        type
        message
      }
    }
  }
`;

export const ON_LOG_ADDED = gql`
  subscription MyQuery($date: String) {
    onLogAdded(date: $date) {
      transaction {
        timestamp
        status {
          consent
          carriers
          login
          webhook
          pull
        }
        output_payload
        created_at
        is_issue
        employeeName
        dealershipName
        customer {
          fullName
          email
          contactNumber
          vin
          address
        }
        pull {
          pullId
          carrier
          policies
          documents
        }
      }
      date
    }
  }
`;
